// Money formatter — converts Shopify cents → "$X.XX"
function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    const dollars = (parseInt(cents, 10) / 100).toFixed(2);
    return "$" + dollars;
}

//  For each product on the page
/* main-product.js — last edit 2026-05-06 sold-out flavor handling */
document.querySelectorAll(".product").forEach((section) => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(
        section.querySelector(".activeVariantJSON").textContent
    );
    let quantity = 1;

    /************
     Product Swiper
     ************/

    // Per-product swiper overrides. Pheromone PDPs (Muse, Gravity) open on the 2nd slide and auto-advance every 5s;
    // every other product keeps the default (slide 0, manual advance).
    // `section` here is the .product element itself (see outer forEach), so the data attr is on `section`.
    const productHandle = section.dataset.productHandle;
    const pheromoneSwiperOverrides = (productHandle === "tabs-muse-pheromone-perfume" || productHandle === "tabs-gravity")
        ? { initialSlide: 1, autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true } }
        : {};

    const swiperOptions = {
        slidesPerView: 1,
        loop: true,
        // autoplay disabled by default — user advances manually via thumbnails / arrows
        initialSlide: 0,
        ...pheromoneSwiperOverrides,
        on: {
            init: function () {
                // set initial active pagination color to product color
                section
                    .querySelectorAll(".swiper-pagination-bullet")
                    ?.forEach((element) => {
                        if (element.classList.contains("swiper-pagination-bullet-active")) {
                            element.style.backgroundColor = element
                                .closest(".swiper-pagination")
                                ?.getAttribute("data-color");
                        } else {
                            element.style.backgroundColor = "#FFFAF0";
                        }
                    });
                // sync thumbnail active state on init
                syncActiveThumb(this);
            },
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }
                // set pagination color to product color
                section
                    .querySelectorAll(".swiper-pagination-bullet")
                    ?.forEach((element) => {
                        if (element.classList.contains("swiper-pagination-bullet-active")) {
                            element.style.backgroundColor = element
                                .closest(".swiper-pagination")
                                ?.getAttribute("data-color");
                        } else {
                            element.style.backgroundColor = "#FFFAF0";
                        }
                    });
                // sync thumbnail active state when slide changes
                syncActiveThumb(this);
            },
        },
    };

    // Helper: highlight the thumbnail matching the active slide
    function syncActiveThumb(swiper) {
        const wrap = swiper.el.closest(".productVisualSwiperWrap");
        if (!wrap) return;
        const thumbs = wrap.querySelectorAll(".productVisualThumb");
        thumbs.forEach((t) => t.classList.remove("is-active"));
        // realIndex tracks the true slide index when loop is enabled
        const idx = typeof swiper.realIndex === "number" ? swiper.realIndex : swiper.activeIndex;
        const active = wrap.querySelector(`.productVisualThumb[data-thumb-index="${idx}"]`);
        if (active) active.classList.add("is-active");
    }

    const multipleSwipers = section.querySelector(".productVisual.multiple");

    // Helper: wire thumbnail click → swiper.slideToLoop (works with loop mode)
    function wireThumbnails(swiperEl, swiperInstance) {
        const wrap = swiperEl.closest(".productVisualSwiperWrap");
        if (!wrap) return;
        wrap.querySelectorAll(".productVisualThumb").forEach((thumb) => {
            thumb.addEventListener("click", (e) => {
                e.preventDefault();
                const idx = parseInt(thumb.dataset.thumbIndex, 10);
                if (isNaN(idx)) return;
                if (typeof swiperInstance.slideToLoop === "function") {
                    swiperInstance.slideToLoop(idx);
                } else {
                    swiperInstance.slideTo(idx);
                }
            });
        });
    }

    // setup product swiper/s
    if (multipleSwipers) {
        section
            .querySelectorAll(".productVisualSwiper")
            .forEach(async (element) => {
                const productSwiper = await new Swiper(element, {
                    ...swiperOptions,
                    navigation: {
                        nextEl: element.querySelector(".productVisualSwiperNext"),
                        prevEl: element.querySelector(".productVisualSwiperPrev"),
                    },
                    pagination: {
                        el: element.querySelector(".swiper-pagination"),
                    },
                });
                wireThumbnails(element, productSwiper);
            });
    } else {
        // setup single swiper
        const swiperEl = section.querySelector(".productVisualSwiper");
        const productSwiper = new Swiper(swiperEl, {
            ...swiperOptions,
            navigation: {
                nextEl: section.querySelector(".productVisualSwiperNext"),
                prevEl: section.querySelector(".productVisualSwiperPrev"),
            },
            pagination: {
                el: section.querySelector(".swiper-pagination"),
            },
        });
        wireThumbnails(swiperEl, productSwiper);
    }

    /**************
     Update Product
     ***************/

    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch((e) => console.error(e));
        });
    });

    async function updateProduct() {
        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;
        let sellingPlanExists = section.querySelector(".productSelling") || false;

        const activeVariant = getActiveVariant();
        const activeVariantATC = getActiveVariantForATC();

        // check if variant wasn't found
        if (!activeVariantATC) {
            section.querySelector(".productATCButton").disabled = true;
            section.querySelector(".productATCButton").textContent = "Not Available";
            return;
        }

        if (multipleSwipers) {
            // Normalize option1 to a class (matches Liquid's "replace ' ' with '-'")
            const optionClass = (activeVariant.option1 || "").replace(/\s+/g, "-");
            // hide existing active wrap (swiper + its thumbnails)
            section.querySelectorAll(".productVisualSwiperWrap.active").forEach((el) => el.classList.remove("active"));
            section.querySelectorAll(".productVisualSwiper.active").forEach((el) => el.classList.remove("active"));
            // reveal matching media + thumbnails for the selected variant
            if (optionClass) {
                const escaped = (window.CSS && CSS.escape) ? CSS.escape(optionClass) : optionClass;
                const matchWrap = section.querySelector(`.productVisualSwiperWrap.${escaped}`);
                const matchSwiper = section.querySelector(`.productVisualSwiper.${escaped}`);
                if (matchWrap) matchWrap.classList.add("active");
                if (matchSwiper) {
                    matchSwiper.classList.add("active");
                    matchSwiper.swiper?.slideTo(0);
                }
            }
        }

        // Change the color of the labels
        document
            .querySelectorAll(".productQuantityValuesLabelInput")
            .forEach(function (element) {
                const isChecked = element.checked;
                const variantColors = document.querySelector(
                    '.productOptionItemValuesLabelInput[name="flavor"]:checked'
                )?.dataset.color;
                const bgColor = variantColors
                    ? variantColors.split("/")[0]
                    : element.getAttribute("data-color");
                const textColor = variantColors
                    ? variantColors.split("/")[1]
                    : element.getAttribute("data-textColor");
                const neighbor = element.nextElementSibling;

                neighbor.style.backgroundColor = isChecked ? bgColor : "";
                neighbor.style.color = isChecked ? textColor : "#000901";
                if (
                    neighbor.querySelector(
                        ".productQuantityValuesLabelSelectorComparePrice"
                    )
                ) {
                    bgColor === "#ffffff" || bgColor === "#fffaf0"
                        ? (neighbor.querySelector(
                            ".productQuantityValuesLabelSelectorComparePrice"
                        ).style.color = "#000901")
                        : (neighbor.querySelector(
                            ".productQuantityValuesLabelSelectorComparePrice"
                        ).style.color = "#fffaf0");
                }
            });

        /**************
         Selling Plan
         ***************/

        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (
                    plan.selling_plan_id ===
                    parseInt(
                        section.querySelector(
                            ".productSellingLabelBodyBottomWrapContentLabelInput:checked"
                        ).value
                    )
                ) {
                    activeVariantPlan = plan;
                }
            }

            // update savings text
            let save = (1 - activeVariantPlan.price / activeVariant.price) * 100;
            section.querySelector(".productSellingLabelBodyTopTitle").textContent =
                `Subscribe & Save ` + save.toFixed(0) + `%`;

            // save parent elements
            const once = section.querySelector(".productSellingLabelBody.once");
            const sub = section.querySelector(".productSellingLabelBody.sub");

            // update compare at price
            once.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                "";
            sub.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                price(activeVariantPlan.compare_at_price * quantity, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                once.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                    price(activeVariant.compare_at_price * quantity, true);
            }

            // update actual price
            once.querySelector(".productSellingLabelBodyPriceReal").textContent =
                price(activeVariant.price * quantity, true);
            sub.querySelector(".productSellingLabelBodyPriceReal").textContent =
                price(activeVariantPlan.price * quantity, true);

            // update price outside of selling plan module if selling plan is selected
            if (
                section.querySelector(".productSellingLabelInput:checked")?.value ===
                "sub"
            ) {
                section.querySelector(".productPriceReal").textContent = price(
                    activeVariantPlan.price * quantity
                );
                section.querySelector(".productPriceCompare").textContent = price(
                    activeVariantPlan.compare_at_price * quantity
                );
                section.querySelector(
                    ".productPriceSavings"
                ).textContent = `Save ${Math.round(
                    ((activeVariantPlan.compare_at_price - activeVariantPlan.price) *
                        100) /
                    activeVariantPlan.compare_at_price
                )}%`;
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // Resolve the variant matching BOTH the selected flavor and box-quantity radio.
        // The quantity radio's hardcoded variant_id only encodes the box count for one flavor,
        // so for a different flavor we have to look up the matching variant ourselves.
        // If the exact (flavor + box-count) combo doesn't exist in Shopify (some flavors have
        // no 1-box variant), we treat the flavor as unavailable rather than silently picking
        // a different flavor's variant — that way the ATC button correctly reflects sold-out.
        const productData = JSON.parse(section.querySelector(".productJSON").textContent);
        const checkedQtyInput = section.querySelector('.productQuantityValuesLabelInput[name="variant_id"]:checked');
        const flavorInput = section.querySelector('input[name="flavor"]:checked');
        const flavorVal = flavorInput?.value;
        const boxCount = checkedQtyInput?.dataset.boxCount; // e.g. "1", "2", "3"
        let qtyVariant = activeVariant;
        let exactComboFound = false;
        if (flavorVal && boxCount) {
            const found = productData.variants.find((v) => {
                if (v.option1 !== flavorVal) return false;
                const opt2 = (v.option2 || "").toLowerCase().trim();
                // Match the leading number, e.g. "2 boxes" → 2
                const m = opt2.match(/^(\d+)/);
                return m && m[1] === String(boxCount);
            });
            if (found) {
                qtyVariant = found;
                exactComboFound = true;
            } else {
                // No (flavor, box-count) match — fabricate an unavailable stub
                // so disabled-state logic kicks in.
                qtyVariant = { ...activeVariant, available: false };
                exactComboFound = true;
            }
        }
        if (!exactComboFound && checkedQtyInput && checkedQtyInput.value) {
            try {
                const parsedId = JSON.parse(checkedQtyInput.value);
                const idNum = parseInt(parsedId, 10);
                const found = productData.variants.find((v) => v.id === idNum);
                if (found) qtyVariant = found;
            } catch (err) { /* fallback to activeVariant */ }
        }

        if (section.querySelector(".productATCButton")) {
            const atcBtn = section.querySelector(".productATCButton");
            const labelEl = atcBtn.querySelector(".productATCButtonLabel");
            const priceEl = atcBtn.querySelector(".productATCButtonPrice");

            if (qtyVariant.available !== false) {
                atcBtn.disabled = false;
                if (labelEl) {
                    labelEl.textContent = "Add To Cart";
                    if (priceEl) priceEl.textContent = "";
                } else {
                    atcBtn.textContent = "Add To Cart";
                }
            } else {
                atcBtn.disabled = true;
                atcBtn.textContent = "Sold Out";
            }
        }

        // Plan-toggle prices — keep both states in sync with the selected box variant
        // Toggle prices are PER BOX so multi-box variants show the right unit price.
        // qtyVariant.price is the total for the chosen box count (e.g. 2 boxes = $55.80),
        // so divide by box count to get the per-box price.
        const bcForToggle = parseInt(boxCount, 10) || 1;
        const perBoxOtpCents = Math.round(qtyVariant.price / bcForToggle);
        const togglePriceOnce = section.querySelector(".productATCPlanTogglePriceOnce");
        if (togglePriceOnce && qtyVariant.price != null) {
            togglePriceOnce.textContent = formatMoney(perBoxOtpCents);
        }
        const togglePriceSub = section.querySelector(".productATCPlanTogglePriceSub");
        if (togglePriceSub && qtyVariant.price != null) {
            // Match the subscription card's 10%-off rule so the two stay in sync.
            togglePriceSub.textContent = formatMoney(Math.round(perBoxOtpCents * 0.9));
        }

        // Free-shipping indicator — toggles based on the selected plan's total
        const shipEl = section.querySelector(".productFreeShipping");
        const shipText = section.querySelector(".productFreeShippingText");
        if (shipEl && shipText) {
            const threshold = parseInt(shipEl.dataset.threshold, 10) || 6000;
            const isSubActive = !!section.querySelector('.productBuyingOption.active[data-plan="subscription"]');
            let total = qtyVariant.price;
            if (isSubActive) {
                total = Math.round(qtyVariant.price * 0.9);
            }
            if (total >= threshold) {
                if (shipEl.dataset.state !== "unlocked") {
                    shipEl.dataset.state = "unlocked";
                    // retrigger the pop animation each time we cross the threshold
                    shipEl.classList.remove("freeShip-pop");
                    void shipEl.offsetWidth;
                    shipEl.classList.add("freeShip-pop");
                }
                shipText.textContent = "Free shipping unlocked!";
            } else {
                shipEl.dataset.state = "locked";
                shipEl.classList.remove("freeShip-pop");
                const remaining = threshold - total;
                shipText.textContent = formatMoney(remaining) + " away from free shipping";
            }
        }

        // Swap the "What's in it" content to match the selected flavor
        if (flavorInput) {
            let slug = flavorInput.value
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");
            // play-chocolate labels the Dark flavor as "Black" — normalize so
            // it picks up the dark variant content blocks.
            if (slug === "black") slug = "dark";
            section.querySelectorAll(".productVariantContent").forEach((el) => {
                const target = el.dataset.variantSlug;
                // Lenient match: exact, or either contains the other (handles "pink" vs "pink-cherry")
                const matches = slug === target
                    || (slug && target && (slug.includes(target) || target.includes(slug)));
                if (matches) {
                    el.setAttribute("data-active", "true");
                } else {
                    el.removeAttribute("data-active");
                }
            });
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch((e) => console.error(e));
    // Update prices on page load for default quantity
    updateBuyingOptionPrices(section);

    /**************
     Product Quantity
     ***************/

    // minus
    section
        .querySelectorAll(".productQuantityControlsBtn.minus")
        ?.forEach((element) => {
            element.addEventListener("click", function () {
                if (quantity === 1) return;
                quantity--;
                section
                    .querySelectorAll(".productQuantityControlsValue")
                    ?.forEach((element) => (element.textContent = quantity));
                updateProduct().catch((e) => console.error(e));
            });
        });

    // plus
    section
        .querySelectorAll(".productQuantityControlsBtn.plus")
        ?.forEach((element) => {
            element.addEventListener("click", function () {
                quantity++;
                section
                    .querySelectorAll(".productQuantityControlsValue")
                    ?.forEach((element) => (element.textContent = quantity));
                updateProduct().catch((e) => console.error(e));
            });
        });

    // Handle quantity selection changes and update prices
    section
        .querySelectorAll(".productQuantityValuesLabelInput")
        .forEach((input) => {
            input.addEventListener("change", function () {
                updateBuyingOptionPrices(section);
            });
        });

    /***********
     Sticky ATC
     ***********/

    const productContent = section.querySelector('.productInner');

    // sticky ATC height, adds to footer padding
    const stickyHeight = section.querySelector('.productATCFixed')?.offsetHeight || 0;
    // keep track of the position
    let position = window.scrollY;
    // keep track of how often called and provide a buffer for smoother experience
    let coolDown = false;
    // handle sticky ATC
    const updateSticky = () => {
        if (coolDown) return;
        const productBottom = productContent.getBoundingClientRect().bottom;
        // disappear on scroll up, prevents issues with mobile nav bars
        if (window.scrollY < position && window.innerWidth <= 500) {
            section.querySelector('.productATCFixed').style.top = '100dvh';
            document.querySelector('#footer').style.paddingBottom = '20px';
            // reset the position
            position = window.scrollY;
            return;
        }
        // if the main product section has scrolled off screen, apply active
        if (productBottom <= 0) {
            section.querySelector('.productATCFixed').style.top = `${100 - ((stickyHeight / window.innerHeight) * 100)}dvh`;
            document.querySelector('#footer').style.paddingBottom = `${stickyHeight + 20}px`;
        } else {
            section.querySelector('.productATCFixed').style.top = '100dvh';
            document.querySelector('#footer').style.paddingBottom = '20px';
        }
        // reset the position
        position = window.scrollY;
        // set slight pause
        coolDown = true;
        setTimeout(() => {
            coolDown = false;
        }, 300)
    }

    window.addEventListener('scroll', updateSticky, {passive: true});

    window.addEventListener("scroll", updateSticky, {passive: true});

    document
        .querySelector(".productStickyATCButton")
        ?.addEventListener("click", addProductToCart);

    /**************
     Product ATC
     ***************/

    document
        .querySelector(".productATCButton")
        ?.addEventListener("click", addProductToCart);

    // changing from OTP to Subscription
    document.querySelectorAll(".productBuyingOption").forEach((el) => {
        el.addEventListener("click", function () {
            // if the buying option is already active, return
            if (this.classList.contains("active")) return;

            this.closest(".productInner")
                ?.querySelectorAll(".productBuyingOption.active")
                ?.forEach((item) => {
                    // if the buying option doesn't match the data plan attribute, remove active class from each
                    if (item.dataset.plan !== el.dataset.plan) {
                        item.classList.remove("active");
                    }
                    // if the buying option matches the data plan attribute, add active class
                    section.querySelectorAll(".productBuyingOption")?.forEach((e) => {
                        if (e.dataset.plan === el.dataset.plan) {
                            e.classList.add("active");
                        }
                    });
                });
        });
    });

    // Plan toggle — flips between OTP and subscription, syncing body class so the
    // toggle's label updates to reflect what clicking it will do next.
    function syncPlanModeClass() {
        const subActive = !!section.querySelector('.productBuyingOption.active[data-plan="subscription"]');
        const otpActive = !!section.querySelector('.productBuyingOption.active[data-plan="OTP"]');
        document.body.classList.toggle("plan-mode-subscription", subActive);
        document.body.classList.toggle("plan-mode-otp", otpActive || (!subActive && !otpActive));
    }
    syncPlanModeClass();
    section.querySelectorAll(".productBuyingOption").forEach((el) => {
        el.addEventListener("click", () => {
            // Run after the existing buying-option handler has flipped .active classes.
            window.requestAnimationFrame(syncPlanModeClass);
        });
    });
    // Plan CTA — adds the product to the cart with the OPPOSITE plan to the
    // currently-active one (so the visible link is a one-tap shortcut for the
    // alternate plan). Doesn't change the active card.
    section.querySelectorAll("[data-plan-toggle]").forEach((el) => {
        el.addEventListener("click", async function (e) {
            e.preventDefault();
            const subCard = section.querySelector('.productBuyingOption[data-plan="subscription"]');
            const otpActive = !!section.querySelector('.productBuyingOption.active[data-plan="OTP"]');

            // Resolve the subscription's selling_plan_id from the dropdown if
            // present, otherwise fall back to the card's data attribute.
            let subPlanId = null;
            const subSelector = section.querySelector(".productSubscription .productSubscriptionSelector");
            if (subSelector) {
                subPlanId = parseInt(subSelector.value || subSelector.getAttribute("selling_plan_id")) || null;
            }
            if (!subPlanId && subCard?.dataset.subscription) {
                subPlanId = parseInt(subCard.dataset.subscription) || null;
            }

            // OTP active → CTA reads "Subscribe & Save" → add subscription
            // Sub active → CTA reads "Buy It Once For" → add one-time purchase
            const sellingPlan = otpActive ? subPlanId : null;

            el.classList.add("loading");
            try {
                await addProductToCart(e, { sellingPlan });
            } catch (err) {
                console.error("Plan CTA add-to-cart failed:", err);
            } finally {
                el.classList.remove("loading");
            }
        });
    });

    section
        .querySelectorAll(".productContentInfoTitle")
        .forEach(function (element) {
            element.addEventListener("click", function () {
                if (this.classList.contains("active")) {
                    this.classList.remove("active");
                    return;
                }
                section
                    .querySelectorAll(".productContentInfoTitle.active")
                    .forEach(function (element) {
                        element.classList.remove("active");
                    });
                this.classList.add("active");
            });
        });

    function openAccordionFromHash() {
        const hash = window.location.hash.replace("#", "");
        if (!hash) return;
        const target = section.querySelector(".productContentIngredients#" + CSS.escape(hash));
        if (!target) return;
        section
            .querySelectorAll(".productContentInfoTitle.active")
            .forEach((el) => el.classList.remove("active"));
        target.querySelector(".productContentInfoTitle")?.classList.add("active");
        target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    openAccordionFromHash();
    window.addEventListener("hashchange", openAccordionFromHash);
});

// Create a function to retrieve the active variant
function getActiveVariant() {
    // Get the product
    const product = JSON.parse(
        document.querySelector(".productJSON").textContent
    );

    // Get the options
    let options = Array.from(document.querySelectorAll(`.productOptionItem`))
        // Skip box option
        .filter(
            (optionGroup) =>
                optionGroup.querySelector("input:checked")?.getAttribute("name") !==
                "box"
        )
        // Skip options without a value
        .filter((optionGroup) =>
            optionGroup.querySelector("input:checked")?.getAttribute("value")
        )
        // map out checked options
        .map((optionGroup) => optionGroup.querySelector("input:checked")?.value);

    // Find the active variant. The `options` array only includes the user-facing
    // option groups inside `.productOptionItem` (i.e. flavor) — it does NOT
    // include the quantity radio (which lives in a separate `.productQuantity`
    // container). So a strict equality with `variant.options` would always fail
    // for products that also have a box-count option, and we'd silently fall
    // back to `product.variants[0]` — flipping the image back to the first
    // flavor whenever the user changed quantity.
    //
    // Match positionally: first variant whose leading options match what the
    // user has actually selected, regardless of the trailing options.
    const activeVariant = product.variants.find((variant) => {
        if (!variant.options) return false;
        for (let i = 0; i < options.length; i++) {
            if (variant.options[i] !== options[i]) return false;
        }
        return true;
    });

    return activeVariant || product.variants[0];
}

function getActiveVariantForATC() {
    // Get the product
    const product = JSON.parse(
        document.querySelector(".productJSON").textContent
    );

    // Get the options
    let options = Array.from(document.querySelectorAll(`.productOptionItem`))
        // Skip box option
        .filter(
            (optionGroup) =>
                optionGroup.querySelector("input:checked")?.getAttribute("name") !==
                "box"
        )
        // Skip options without a value
        .filter((optionGroup) =>
            optionGroup.querySelector("input:checked")?.getAttribute("value")
        )
        // map out checked options
        .map((optionGroup) => optionGroup.querySelector("input:checked").value);

    const quantityValue = document
        .querySelector(".productQuantityValuesLabelInput:checked")
        ?.getAttribute("data-option");
    // options = [options[0], quantityValue];

    // Find the active variant
    let activeVariant;
    if (options.length > 0) {
        activeVariant = product.variants.find(
            (variant) =>
                variant.option1 === options[0] && variant.option2.includes("1")
        );
    } else {
        activeVariant = product.variants.find((variant) => variant.option1 === 1);
    }

    return activeVariant || product.variants[0];
}

// Get all the product option item inputs
document.querySelectorAll(".productOptionItemValuesLabelInput").forEach(function (element) {
    // Create an event listener to update the label text
    element.addEventListener("change", function (e) {
        // Create a variable to store the corresponding label
        const correspondingLabel = document.querySelector(
            `.productOptionItem[data-option="${e.target.name}"] .productOptionItemLabelSelection`
        );

        // Exit if no corresponding label
        if (!correspondingLabel) {
            return;
        }

        // Update the corresponding labels text content to the selected value
        correspondingLabel.textContent = e.target.dataset.alt
            ? e.target.dataset.alt
            : e.target.value;

        // Create an event listener to update the active variant image
        if (element.getAttribute("name") === "flavor") {
            slideSwiperToActiveVariantImage();
        }
    });

});

// Create a function to slide the swiper to the active variant image
function slideSwiperToActiveVariantImage() {
    // Find the active variant
    const activeVariant = getActiveVariantForATC();

    if (document.querySelector(".productVisual.multiple")) {
        // hide existing active wrap + swiper
        document.querySelectorAll(".productVisualSwiperWrap.active").forEach((el) => el.classList.remove("active"));
        document.querySelectorAll(".productVisualSwiper.active").forEach((el) => el.classList.remove("active"));
        // reveal matching media (normalize spaces to "-")
        const optionName = (activeVariant.option1 || "").replace(/\s+/g, "-");
        const escaped = (window.CSS && CSS.escape) ? CSS.escape(optionName) : optionName;
        const matchWrap = document.querySelector(`.productVisualSwiperWrap.${escaped}`);
        const matchSwiper = document.querySelector(`.productVisualSwiper.${escaped}`);
        if (matchWrap) matchWrap.classList.add("active");
        if (matchSwiper) {
            matchSwiper.classList.add("active");
            matchSwiper.swiper?.slideTo(0);
        }
    } else {

        // If there is no featured image for the active variant exit
        if (!activeVariant.featured_image) {
            return;
        }

        // Get the product swiper
        const productSwiper = document.querySelector(".productVisualSwiper");

        // change active slide
        productSwiper.swiper?.slideTo(activeVariant.featured_image.position - 1);
    }

}

// create a function to get the selected quantity
function getSelectedQuantity() {
    const checkedQty = document.querySelector(
        ".productQuantityValuesLabelInput[name='variant_id']:checked"
    );

    if (!checkedQty) {
        return 1;
    }

    // Extract quantity from the label text or use a default
    const label =
        checkedQty.nextElementSibling?.querySelector(
            ".productQuantityValuesLabelSelectorTitle"
        )?.textContent || "1";

    // Try to extract numeric value from label (e.g., "Box of 30" -> 30)
    const match = label.match(/\d+/);
    return match ? parseInt(match[0]) : 1;
}

// create a function to get the selected selling plan.
// Reads the dropdown's current `value` first (most reliable; updates with each change),
// falls back to the `selling_plan_id` attribute the change handler stamps on.
function getSelectedSellingPlan() {
    const selector = document.querySelector(".productSubscription.active .productSubscriptionSelector");

    if (!selector) {
        return null;
    }

    return parseInt(selector.value || selector.getAttribute("selling_plan_id")) || null;
}

// Validate a selling-plan id against the active variant. If Shopify doesn't have
// an allocation for that plan on this variant, the cart-add request returns 422
// and the line never lands in the cart. We resolve by falling back to the first
// valid allocation for the variant; if none exist, we drop the plan entirely.
function resolveValidSellingPlan(sellingPlan, activeVariant) {
    if (!sellingPlan) return null;
    const allocations = (activeVariant && activeVariant.selling_plan_allocations) || [];
    if (allocations.length === 0) return null;
    const ids = allocations.map((a) => a.selling_plan_id);
    if (ids.includes(sellingPlan)) return sellingPlan;
    // Plan not valid for this variant — fall back to the first available
    return ids[0] || null;
}

// Create a function to add the product to the cart.
// `opts.sellingPlan` (optional) overrides the active plan: pass a numeric
// selling_plan_id to force subscription, or `null` to force one-time purchase.
async function addProductToCart(e, opts) {
    opts = opts || {};

    // update klaviyo item with variant information. we use a try catch since this would break if klaviyo is ever removed or disabled
    let activeVariant;
    try {
        const product = JSON.parse(
            document.querySelector(".productJSON").textContent
        );
        activeVariant = getActiveVariantForATC();
        item.Name = `${product.title} - ${activeVariant.title}`;
        item.URL = window.location.href;
        item.ImageURL = activeVariant.featured_image?.src;
        item.VariantID = activeVariant.id;
    } catch (e) {
    }

    // If the parameter was an event and the target contains the button class add the loading animation
    if (e instanceof Event && e.target.classList.contains("button")) {
        e.target.classList.add("loading");
    }

    const formData = {items: []};

    // Use the explicit sellingPlan override if provided; otherwise derive from active card
    let sellingPlan = Object.prototype.hasOwnProperty.call(opts, "sellingPlan")
        ? opts.sellingPlan
        : getSelectedSellingPlan();

    // Make sure the plan is actually valid for the active variant — otherwise
    // /cart/add.js returns a 422 and silently fails (cart drawer opens empty).
    sellingPlan = resolveValidSellingPlan(sellingPlan, activeVariant);

    // Add items to form data
    formData.items.push({
        id: activeVariant.id,
        quantity: getSelectedQuantity(),
        selling_plan: sellingPlan,
    });

    // add product
    const result = await addProduct(formData);
    if (result && (result.status >= 400 || result.message || result.description)) {
        console.error("cart/add.js failed:", result);
        if (e instanceof Event && e.target.classList.contains("button")) {
            e.target.classList.remove("loading");
        }
        return; // don't open the cart drawer for an empty add
    }

    // If the parameter was an event and the target contains the button class remove the loading animation
    if (e instanceof Event && e.target.classList.contains("button")) {
        e.target.classList.remove("loading");
    }

    // open cart
    await openCart();
}

// Create a function to update buying option prices based on selected quantity
function updateBuyingOptionPrices(section) {
    const checkedQty = section.querySelector(
        ".productQuantityValuesLabelInput[name='variant_id']:checked"
    );

    if (!checkedQty) {
        return;
    }

    // Get the price from the quantity selector
    const priceElement = checkedQty.nextElementSibling?.querySelector(
        ".productQuantityValuesLabelSelectorPrice"
    );

    if (!priceElement) {
        return;
    }

    const priceText = priceElement.textContent;
    // Extract numeric value from price text (e.g., "$30.00" -> 30.00)
    const priceMatch = priceText.match(/[\d.]+/);
    const price = priceMatch ? parseFloat(priceMatch[0]) : 0;

    // Update subscription box price (10% off = 0.9)
    const subscriptionPrice = price * 0.9;
    const subPriceReal = section.querySelector(
        ".productSubscription .productSubscriptionPriceReal"
    );
    const subPriceDose = section.querySelector(".subscriptionPricePerDose");

    if (subPriceReal) {
        subPriceReal.textContent = `$${subscriptionPrice.toFixed(2)} Per Box`;
    }

    if (subPriceDose && price > 0) {
        const servingsPerBox = 6;
        const pricePerServing = (subscriptionPrice / servingsPerBox).toFixed(2);
        subPriceDose.textContent = `$${pricePerServing}/serving`;
    }

    // Update OTP box price
    const otpPrice = section.querySelector(".productOTP .productOTPPrice");
    const otpPriceDose = section.querySelector(".OTPPricePerDose");

    if (otpPrice) {
        otpPrice.textContent = `${priceText} Per Box`;
    }

    if (otpPriceDose && price > 0) {
        const servingsPerBox = 6;
        const pricePerServing = (price / servingsPerBox).toFixed(2);
        otpPriceDose.textContent = `$${pricePerServing}/serving`;
    }
}

// check for url price for og price
const urlPrice = new URLSearchParams(window.location.search).get("price");
if (urlPrice) {
    // update og price
    const metaPrice = document.createElement("meta");
    metaPrice.setAttribute("property", "og:price:amount");
    metaPrice.setAttribute("content", `${parseFloat(urlPrice) / 100}`);
    document.head.appendChild(metaPrice);
}

// check for qty
const urlQty = new URLSearchParams(window.location.search).get("qty");
if (urlQty) {
    // click the quantity
    document.querySelectorAll(".productQuantityValuesLabel")[urlQty - 1]?.click();
}

// CTAs marked [data-scroll-to-buy] (Stats, Testimonials, FAQ) → scroll to the ATC area
// and pulse the Add To Cart button so the user knows where to click next.
document.querySelectorAll("[data-scroll-to-buy]").forEach((el) => {
    el.addEventListener("click", (e) => {
        const atcBtn = document.querySelector(".productATCButton");
        const buyArea = document.querySelector(".productATC") || atcBtn;
        if (!buyArea) return;
        e.preventDefault();
        buyArea.scrollIntoView({ behavior: "smooth", block: "center" });
        if (atcBtn) {
            atcBtn.classList.remove("is-pulsing");
            // Force reflow so the animation restarts on repeat clicks
            void atcBtn.offsetWidth;
            atcBtn.classList.add("is-pulsing");
            window.setTimeout(() => atcBtn.classList.remove("is-pulsing"), 1800);
        }
    });
});
